import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import LineStatusDescriptionsOverlayDialog from '../../dialogs/lineStatusDescriptionsOverlayDialog';
import ProductStatusDescriptionsOverlayDialog from '../../dialogs/productStatusDescriptionsOverlayDialog';

/* Actions */
import {
	getOrderList,
	getOrderDetails,
	saveViewRequestsListBackup,
	ajaxRequestInitiated,
	ajaxRequestCompleted,
	exportManageOrdersDetails,
} from '../../../redux/actions';

import { routes } from '../../../redux/api/routes';
const {
	orders,
	bootAPIUrl,
} = routes;
import {
	sendRequest
} from '../../../redux/api/sendRequest';

class ViewReturnRequests extends Component {

	constructor(props) {
		super(props);
		this.state = {
			batchSizeForGettingOrderDetails: 10,
			orderShippingDetailsList: [],
			pimDetailsList: [],
			showViewRequestOrderStatusDescriptionsOverlayDialog: false,
			accountNumber: '',
			errorMessage: '',
			ordersListResponse: null,
			backupOrdersListResponse: null,
			filterConfirmationMessage: '',

			sortBy: 'orderNumber,desc',

			filterViewRequestByOrderNumber: {
				param: {
					filterBy: '',
					filterString: ''
				},
				error: {
					filterByError: '',
					filterStringError: '',
				}
			},

			fromDate: this.props.convertDateToTimeZone().add(-30, 'days'),
			toDate: this.props.convertDateToTimeZone(),
			maxFromDate: this.props.convertDateToTimeZone(),
			maxToDate: this.props.convertDateToTimeZone(),
			minToDate: this.props.convertDateToTimeZone().add(-routes.horizon, 'days'),
			invalidDateSelectionErrorMessage: '',
			filterViewRequestByDateRange: {
				param: {
					fromDate: this.props.convertDateToTimeZone().add(-30, 'days').format('MM/DD/YYYY'),
					toDate: this.props.convertDateToTimeZone().format('MM/DD/YYYY'),
					productNumber: '',
				},
				error: {
					fromDateError: '',
					toDateError: '',
				}
			}
		};
		this.handleChangeFromDate = this.handleChangeFromDate.bind(this);
		this.handleChangeToDate = this.handleChangeToDate.bind(this);
		this.validateFP = this.validateFP.bind(this);
		this.getOrderList = this.getOrderList.bind(this);
		this.getAttributeValueByLineId = this.getAttributeValueByLineId.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.fetchOrderShippingDetails = this.fetchOrderShippingDetails.bind(this);
		this.checkParallelCallsCompleted = this.checkParallelCallsCompleted.bind(this);
	}

	getAttributeBySalesAgreement(salesAgreement, attributeName) {
		const self = this;
		const { allSelectedAccountsAllPriceSources } = self.props.state.user;
		const saDetails = allSelectedAccountsAllPriceSources.find(item => item.AGREEMENT_NUMBER === parseInt(salesAgreement, 10));
		let attributeValue = '';
		if (saDetails) {
			attributeValue = saDetails[attributeName];
		}
		return attributeValue;
	}

	handleExport(event) {
		event.preventDefault();
		const self = this;
		self.setState({
			errorMessage: ""
		});
		const payload = [];
		self.state.ordersListResponse.responseObject.map(item => {
			const { orderHeader, orderDetail: { orderLine }, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS } = item;
			const shipToValue = orderHeader.parties.party.filter((party)=>party.purpose === "SHIP_TO")||[];
			const addressValue = shipToValue[0].party.partySites.site[0].siteLocation.address || null;
			const locationValue = shipToValue[0].party.partySites.site[0].siteLocation.locationId || null;
			let address1 = "";
			let address2 = "";
			let address3 = "";
			let postalCode = "";
			const shippingMethod = orderHeader.shipmentMethod && orderHeader.shipmentMethod.description;
			let isBackOrderAvailable = false;
			const odrDtl = self.state.orderShippingDetailsList.find(order => order.orderNumber === orderHeader.orderNumber);
			const fullyReservedLine = orderLine.find(itm => self.props.getItemTypeByName(itm.item) !== 'S' && self.getLineType(itm.lineType) === 'Standard' && itm.lineStatus.toUpperCase() !== 'CANCELLED' && itm.reserved !== itm.orderedQty) ? false : true;
			if(addressValue){
				const {address1:add1, address2:add2, address3:add3, postalCode:pcode} = addressValue||{};
				address1 = add1;
				address2 = add2;
				address3 = add3;
				postalCode = pcode;
			}
			else if(isNaN(locationValue)){
				let splitedValue = locationValue.split("|");
				address1 = splitedValue[0];
				address2 = splitedValue[1];
				address3 = splitedValue[2];
				postalCode = (splitedValue.length >= 4 && splitedValue[5]) ?  splitedValue[5] : null;
			}
			const job = orderHeader.attributes.attribute[18].value || "";
			const items = [];
			orderLine.map(itm=>{
				let getLineStatus = self.props.getLineStatusFromMapping(itm.item, orderHeader.shipmentMethod && orderHeader.shipmentMethod.description, itm.lineStatus, itm);
				let standardLineType = itm.lineType === "Standard Line" && getLineStatus !== "Closed" && getLineStatus !== "Entered" ?true: false;
				let extendedPrice ='';
				let suggestedShipDate = '';
				let prdStatus = '';
				let expectedAvailableDate = '';
				let productStatus = '';
				let reservedQty = null;
				const orderStatus = self.props.getLineStatusFromMapping(itm.item, orderHeader.shipmentMethod && orderHeader.shipmentMethod.description, itm.lineStatus, itm);
				let filteredReplacementLineStatus = true;
						if(itm.itemType == null || itm.itemType == ""){
							if((itm.item.indexOf("M") === 0 && itm.item.length === 4) ||  itm.item.indexOf("UNCRATE") !== -1 || itm.item.indexOf("DELIVERY") !== -1 || itm.item.indexOf("SDS TRIP") !== -1 || itm.lineStatus.toLowerCase() =="closed"){
								filteredReplacementLineStatus = false;
							}else{
								filteredReplacementLineStatus = true;
							}
						}else if(itm.itemType == "DELIVERY SERVICE"){
							filteredReplacementLineStatus =false ;
						}
				if(self.getLineType(itm.lineType) === 'Standard') {
					if(!isBackOrderAvailable && orderStatus === 'Backorder Available') {
						isBackOrderAvailable = true;
					}
					if(odrDtl) {
						const itemDetail = odrDtl.items.find(it => it.lineId.toString() === itm.orderLineId.toString());
							suggestedShipDate = itemDetail && itemDetail.suggestedShipDate ? self.props.pickTheDateFromString(itemDetail.suggestedShipDate, 'MM/DD/YY') : '';
							if(!suggestedShipDate) {
								suggestedShipDate = itemDetail && itemDetail.scheduledShipDate ? self.props.pickTheDateFromString(itemDetail.scheduledShipDate, 'MM/DD/YY') : '';
							}
							prdStatus = itemDetail && itemDetail.productStatus;
					}
					if (suggestedShipDate && itm.finalProductionDate != "NULL" && itm.finalProductionDate != undefined) {
						suggestedShipDate = self.validateFP({finalProductionDate: itm.finalProductionDate, suggestedShipDate});
					}
					expectedAvailableDate = filteredReplacementLineStatus && standardLineType  && !fullyReservedLine && !self.props.isItSpecialService(itm.item) && orderStatus.toLowerCase() != "arrived at sds" ? self.calculateAttributeValue(orderStatus, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, item.planNameAndReservedAllLine, shippingMethod, suggestedShipDate, orderHeader):'';
					productStatus =  filteredReplacementLineStatus && standardLineType && orderStatus.toLowerCase() != "arrived at sds"  ? self.calculateAttributeValue(orderStatus, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, item.planNameAndReservedAllLine, shippingMethod, prdStatus, orderHeader):'';
					reservedQty =	filteredReplacementLineStatus && standardLineType ?  self.calculateAttributeValue(orderStatus, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, item.planNameAndReservedAllLine, shippingMethod, itm.reserved, orderHeader, true):null;
				}
				if(itm.itemPrice && itm.itemPrice.salesPrice){
					if(itm.invoicedQty){
						let calculatePrice = +itm.itemPrice.salesPrice * +itm.invoicedQty;
						extendedPrice = parseFloat(calculatePrice).toFixed(2);
					}else if(itm.orderedQty){
						let calculatePrice = +itm.itemPrice.salesPrice * +itm.orderedQty;
						extendedPrice = parseFloat(calculatePrice).toFixed(2);
					}
				}
				items.push({
					lineNo: itm.lineNum,
					lineType: self.getLineType(itm.lineType),
					returnAttribute1:itm.returnAttribute1,
					inventoryItem: itm.inventoryItem,
					userItemDescription: itm.userItemDescription,
					quantity: itm.orderedQty || 0,
					price:itm.itemPrice.salesPrice,
					extendedPrice:extendedPrice,
					reservedQty,
					lineStatus:getLineStatus,
					expectedAvailableDate,
					productStatus,					
				});
			})
			payload.push({
					orderStatus: orderHeader.orderStatus,
					orderNumber: orderHeader.orderNumber,
					poNumber: orderHeader.ponumber,
					orderDate: self.props.pickTheDateFromString(orderHeader.orderDate),
					bookDate:self.props.pickTheDateFromString(orderHeader.bookDate),
					warehouseCode: orderHeader.warehouse && orderHeader.warehouse.warehouseCode,
					deliveryMethod:orderHeader.shipmentMethod && orderHeader.shipmentMethod.description,
					requestedDeliveryDate: self.props.pickTheDateFromString(orderHeader.requestedDeliveryDate),
					orderStartedBy: self.props.pickTheDateFromString(orderHeader.createdDate),
					agreementNumber:orderHeader.salesAgreement.agreementNumber,
					agreementName:self.getAttributeBySalesAgreement(orderHeader.salesAgreement.agreementNumber, 'AGREEMENT_NAME'),
					createdBy: orderHeader.enteredBy,
					address1: address1,
					address2:address2,
					lot:address3,
					postalCode:postalCode,
					job:job,
					items
				});
		});
		this.exportExcelData(self, payload, 'accountNumber=' + self.state.accountNumber+'&requestType=viewReturnAndCredit');
	}

	exportExcelData(self,payload, url){
		self.props.exportManageOrdersDetails(payload, url, (response) => {
			self.props.ajaxRequestCompleted();
			if (!response.status) {
			self.setState({
				errorMessage: response.responseMessage
			});
			} else {
				window.open(response.responseObject);
			}
		});
	}

	handleChangeFromDate(date) {
	  	const self = this;
		const minToDate = date ? date : null;
		let toDateMomentObj = self.state.toDate;
		let { toDate } = self.state.filterViewRequestByDateRange.param;
		if (date && date.isAfter(toDateMomentObj)) {
			toDateMomentObj = null;
			toDate = '';
		}
	  	self.setState({
		  	fromDate: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : date,
			toDate: toDateMomentObj,
			minToDate,
			invalidDateSelectionErrorMessage: '',
			filterViewRequestByDateRange: {
				...self.state.filterViewRequestByDateRange,
				param: {
					...self.state.filterViewRequestByDateRange.param,
			  		fromDate: date && date.format('MM/DD/YYYY'),
					toDate,
				},
				error: {
					...self.state.filterViewRequestByDateRange.error,
					fromDateError: ""
				}
		  	}
	  	});
	}

	handleChangeToDate(date) {
	  	const self = this;
	  	self.setState({
		  	toDate: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : date,
			invalidDateSelectionErrorMessage: '',
			filterViewRequestByDateRange: {
				...self.state.filterViewRequestByDateRange,
				param: {
					...self.state.filterViewRequestByDateRange.param,
			  		toDate: date && date.format('MM/DD/YYYY')
				},
				error: {
					...self.state.filterViewRequestByDateRange.error,
					toDateError: ""
				}
		  	}
	  	});
	}

	validateFP(item) {
		const self = this;
		let finalProductionDate = null;
		if(item.finalProductionDate && item.finalProductionDate !== 'NULL') {
			finalProductionDate = item.finalProductionDate;
		}
		return self.props.checkIfFPForManageOrder({
			finalProductionDate,
			suggestedShipDate: item.suggestedShipDate
		});
	}

	getAttributeValueByLineIdForSuggestedShipDate(details, orderDate ,attrName){
		let value = '';
		const isFromAccountClassificationInExceptionList = this.props.isAccountClassificationInExceptionList();
		let data = details && details.csobacklogdetailsrec && details.csobacklogdetailsrec.value && details.csobacklogdetailsrec.value.csobacklogdetails;
		if (data && data.length > 0 && data[0] && data[0][attrName] && data[0][attrName].value) {
			value = data[0][attrName].value;
		}else{
			if(moment(orderDate).isBetween(moment().add(-2, "days"), moment())){
				if(!isFromAccountClassificationInExceptionList){
					value =  details ? details.scheduleshipdate.value : "";
				}
				else{
					value = "1"
				}
			}else{
				value = ''
			}
		}
		return value;
	}

	getAttributeValueByLineId(details, attrName) {
		const self = this;
		let value = '';
		let data = details && details.isodetailsrec && details.isodetailsrec.value && details.isodetailsrec.value.isodetails;
		if (data && data.length) {
			data = data[0] && data[0].isobacklogdetailsrec && data[0].isobacklogdetailsrec.value && data[0].isobacklogdetailsrec.value.isobacklogdetails;
		}
		if (!data || data.length === 0) {
			data = details && details.csobacklogdetailsrec && details.csobacklogdetailsrec.value && details.csobacklogdetailsrec.value.csobacklogdetails;
		}
		if (data && data.length && data[0] && data[0][attrName] && data[0][attrName].value) {
			if (attrName === 'supplytype') {
				let details = null;
				let highestWeightage = 0;
				data.forEach(it => {
					const priorityDetails = self.props.state.order.productStatus.find(itm => itm.supplyType.toLowerCase() === it.supplytype.value.toLowerCase());
					if(priorityDetails && priorityDetails.weightagePriority > highestWeightage) {
						highestWeightage = priorityDetails.weightagePriority;
						details = it;
					}
				});
				const status = self.props.state.order.productStatus.find(itm => itm.supplyType.toLowerCase() === details.supplytype.value.toLowerCase());
				if(status) {
					value = status.productStatus;
				}
			} else {
				value = data[0][attrName].value;
			}
		}
		return value;
	}

	componentWillMount() {
		const self = this;
		const { viewRequestsListBackup } = self.props.state.order;
		if(viewRequestsListBackup) {
			self.setState({
				...viewRequestsListBackup,
			});
			self.props.saveViewRequestsListBackup(null);
		} else {
			self.props.saveViewRequestsListBackup(null);
		}
	}

	componentDidMount() {
		var self = this,
			accountNumber = self.props.getSelectedAccountNumber();
		if(accountNumber) {
			self.setState({
				accountNumber: accountNumber
			});
		} else {
			browserHistory.push('/manageorders');
		}
	}

	getOrderList(queryString, callback) {
		var self = this;
		self.setState({
			ordersListResponse: null,
			backupOrdersListResponse: null,
			errorMessage: ''
		}, () => {
			self.props.getOrderList(queryString, (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					let sortBy = self.state.sortBy.split(',')[0],
						sortOrder = self.state.sortBy.split(',')[1];

					//Filter all orders which are not 'CANCELLED'
					response.responseObject = _.filter(response.responseObject, item => {
						return item.orderHeader.orderStatus !== 'CANCELLED' && item.orderHeader.orderType === "Return Order";
					});
					// Add optional Product # search
					if(self.state.whichTypeOfSearch === 'filterViewRequestByDateRange') {
						const productNumber = self.state.filterViewRequestByDateRange.param.productNumber.toUpperCase().trim();
						if(productNumber) {
							response.responseObject = _.filter(response.responseObject, item => {
								return _.filter(item.orderDetail.orderLine, itm => {
									return itm.item.indexOf(productNumber) === 0
								}).length > 0 ? item : null;
							});
						}
					}
					// Populate enteredBy so that no need to customize and iterate again for checking enteredBy
					response.responseObject.forEach((item) => {
						let { attribute } = item.orderHeader.attributes;
						attribute = attribute?_.find(attribute, ['name', 'Attribute2']):null;
						if(attribute) {
							item.orderHeader.enteredBy = attribute.value;
						}
					});
					response.responseObject = _.orderBy(response.responseObject, (e) => { return e.orderHeader[sortBy]}, [sortOrder]);

					callback && callback(response);
				}
			});
		});
	}

	sortLineByLineNum(response) {
		response.responseObject.forEach(item => {
			item.orderDetail.orderLine.sort((a, b) => a.lineNum - b.lineNum);
		});
		return response;
	}

	filterReturnRequestByRequestNumber(event) {
		event.preventDefault();
		const self = this;
		let { filterViewRequestByOrderNumber } = this.state;
		self.setState({
			whichTypeOfSearch: 'filterViewRequestByOrderNumber'
		}, () => {
			let anyError = false;
			if (
				(filterViewRequestByOrderNumber.param.filterBy === 'orderNumber' && !self.props.isValidOrderNumer(filterViewRequestByOrderNumber.param.filterString)) ||
				(filterViewRequestByOrderNumber.param.filterBy === 'referenceNumber' && !self.props.isValidReferenceNumber(filterViewRequestByOrderNumber.param.filterString))
			) {
				anyError = true;
			}
			if(!anyError && filterViewRequestByOrderNumber.param.filterBy !== '' && filterViewRequestByOrderNumber.param.filterString !== '') {
				let filterString = filterViewRequestByOrderNumber.param.filterString;
				if(filterViewRequestByOrderNumber.param.filterBy === 'poNumber') {
					filterString = encodeURIComponent(filterString);
				}
				self.getOrderList(`accountNumber=${self.state.accountNumber}&${filterViewRequestByOrderNumber.param.filterBy}=${filterString}&viewReturnsCredits=Y`, (response, showClickHereLink) => {
					response = self.sortLineByLineNum(response);
					let ordersListResponse = JSON.parse(JSON.stringify(response));
					const finalData = JSON.parse(JSON.stringify(response));
					finalData.responseObject = finalData.responseObject.filter(item => item.orderDetail.orderLine.find(itm => self.props.getItemTypeByName(itm.item) !== 'S' && self.getLineType(itm.lineType) === 'Standard' && itm.lineStatus.toUpperCase() !== 'CANCELLED'));
					self.setState({
						ordersListResponse: ordersListResponse,
						backupOrdersListResponse: JSON.parse(JSON.stringify(response)),
						ordersListResponseForParallelCalls: finalData,
						filterConfirmationMessage: '', // ordersListResponse.responseObject.length === 0?'Order could not be found. You must contact your Area Sales Manager to request a return outside of the 90 days.':''
					}, () => {
						// If orderType is BACKORDER then need to make parallel order details calls
						self.fetchOrderDetailsList();
						//Save return product list into store
						self.props.saveViewRequestsListBackup(JSON.parse(JSON.stringify(self.state)));
					});
				});
			} else {
				let error = this.state.filterViewRequestByOrderNumber.error;
				if(filterViewRequestByOrderNumber.param.filterBy === '') {
					error.filterByError = 'error';
				} else if (anyError) {
					if (filterViewRequestByOrderNumber.param.filterBy === 'orderNumber' && !self.props.isValidOrderNumer(filterViewRequestByOrderNumber.param.filterString)) {
						error.filterStringError = 'error';
					}
					if (filterViewRequestByOrderNumber.param.filterBy === 'referenceNumber' && !self.props.isValidReferenceNumber(filterViewRequestByOrderNumber.param.filterString)) {
						error.filterStringError = 'error';
					}
				} else {
					error = {
						...error,
						filterStringError: filterViewRequestByOrderNumber.param.filterString === '' ? 'error' : ''
					}
				}
				self.setState({
					filterViewRequestByOrderNumber: {
						...this.state.filterViewRequestByOrderNumber,
						error: error
					},
					filterConfirmationMessage: ''
				})
			}
		});
	}
	handleResetForm(event) {
		const self = this;
		if(event === "filterViewRequestByOrderNumber"){
			self.setState({
			filterViewRequestByOrderNumber: {
				param: {
					filterBy: '',
					filterString: ''
				},
				error: {
					filterByError: '',
					filterStringError: '',
				}
			}
		});
		}else if(event === 'filterViewRequestByDateRange'){
			self.setState({
				fromDate: self.props.convertDateToTimeZone().add(-30, 'days'),
				toDate: self.props.convertDateToTimeZone(),
				filterViewRequestByDateRange: {
					param: {
						fromDate: self.props.convertDateToTimeZone().add(-30, 'days').format('MM/DD/YYYY'),
						toDate: self.props.convertDateToTimeZone().format('MM/DD/YYYY'),
						productNumber: '',
					},
					error: {
						fromDateError: '',
						toDateError: '',
					}
				}
		});
		}

	}

	filterReturnRequestByDateRange(event) {
		event.preventDefault();
		const self = this;
		let { filterViewRequestByDateRange, fromDate, toDate } = self.state;
		self.setState({
			whichTypeOfSearch: 'filterViewRequestByDateRange'
		}, () => {
			if(
				filterViewRequestByDateRange.param.fromDate &&
				filterViewRequestByDateRange.param.toDate &&
				!fromDate.isAfter(toDate)
			) {
				self.getOrderList(`accountNumber=${self.state.accountNumber}&requestType=viewRequests&fromDate=${filterViewRequestByDateRange.param.fromDate}&toDate=${filterViewRequestByDateRange.param.toDate}&viewReturnsCredits=Y`, (response) => {
					response = self.sortLineByLineNum(response);
					let ordersListResponse = JSON.parse(JSON.stringify(response));
					const finalData = JSON.parse(JSON.stringify(response));
					finalData.responseObject = finalData.responseObject.filter(item => item.orderDetail.orderLine.find(itm => self.props.getItemTypeByName(itm.item) !== 'S' && self.getLineType(itm.lineType) === 'Standard' && itm.lineStatus.toUpperCase() !== 'CANCELLED'));
					self.setState({
						ordersListResponse: ordersListResponse,
						backupOrdersListResponse: JSON.parse(JSON.stringify(response)),
						ordersListResponseForParallelCalls: finalData,
						filterConfirmationMessage: ordersListResponse.responseObject.length === 0?'':''
					}, () => {
						// If orderType is BACKORDER then need to make parallel order details calls
						self.fetchOrderDetailsList();
						//Save return product list into store
						self.props.saveViewRequestsListBackup(JSON.parse(JSON.stringify(self.state)));
					});
				})
			} else {
				let error = filterViewRequestByDateRange.error;
				if(!filterViewRequestByDateRange.param.fromDate) {
					error.fromDateError = 'error';
				}
				if(!filterViewRequestByDateRange.param.toDate) {
					error.toDateError = 'error';
				}
				let invalidDateSelectionErrorMessage = '';
				if(fromDate && toDate && fromDate.isAfter(toDate)) {
					invalidDateSelectionErrorMessage = 'From date should be same or before to date';
				}
				this.setState({
					filterViewRequestByDateRange: {
						...this.state.filterViewRequestByDateRange,
						error: error
					},
					filterConfirmationMessage: '',
					invalidDateSelectionErrorMessage,
				});
			}
		});
	}

	fetchOrderShippingDetails(whichBatch) {
		const self = this;
		const { batches } = self.state;
		const promises = [];
		batches[whichBatch - 1].forEach(item => {
			// Get Order Details: getOrderDetails in parallel
			promises.push(
				sendRequest(
					bootAPIUrl,
					orders.getOrderListBoot.path,
					'',
					orders.getOrderListBoot.method,
					'orderNumber='+item.orderHeader.orderNumber+'&requestType=getOrderShippingDetails&accountNumber='+self.props.getSelectedAccountNumber()
				)
			);
		});
		Promise.all(promises).then((responses) => {
			// logic to combine all responses and then run call back
			let responseObject = [];
			if(responses.length > 0) {
				responses.forEach(resp => {
					if(resp.status) {
						if(resp.responseObject) {
							responseObject = responseObject.concat(resp.responseObject);
						}
					} else {
						browserHistory.push('/error');
					}
				});
			} else {
				responseObject = [];
			}
			self.setState({
				orderShippingDetailsList: self.state.orderShippingDetailsList.concat(responseObject)
			}, () => {
				if (whichBatch < self.state.noOfBatches) {
					self.fetchOrderShippingDetails(whichBatch + 1);
				} else {
					self.setState({
						getOrderShippingDetailsCallCompleted: true
					}, () => {
						self.checkParallelCallsCompleted();
					});
					self.props.ajaxRequestCompleted();
				}
			});
		});
	}

	fetchOrderDetailsList() {
		const self = this;
		const { ordersListResponseForParallelCalls: ordersListResponse } = self.state;
		if(ordersListResponse.responseObject && ordersListResponse.responseObject.length > 0) {
			self.props.ajaxRequestInitiated();
			const batches = _.chunk(ordersListResponse.responseObject, self.state.batchSizeForGettingOrderDetails);
			self.setState({
				batches,
				noOfBatches: batches.length,
				getOrderShippingDetailsCallCompleted: false,
			}, () => {
				self.fetchOrderShippingDetails(1);
				self.fetchPimDetails(ordersListResponse.responseObject, self.checkParallelCallsCompleted);
			});
		}
	}

	fetchPimDetails(responseObject, callback) {
		const self = this;
		const skus = [];
		responseObject.forEach(order => {
			const { orderHeader } = order;
			order.orderDetail.orderLine.forEach(itm => {
				if(self.props.checkItemIsServiceOrNot(itm.item) === 'service' || itm.lineStatus.toUpperCase() === 'CANCELLED') {
					return null;
				}
				const orderStatus = self.props.getLineStatusFromMapping(itm.item, orderHeader.shipmentMethod && orderHeader.shipmentMethod.description, itm.lineStatus, itm);
				if (orderStatus.toUpperCase() !== 'CLOSED') {
					skus.push(itm.item);
				}
			});
		});
		// make service call to get pim details
		const skuListForPim = [];
		skus.forEach(sku => {
			if (!self.state.pimDetailsList.find(item => item.item_number === sku) && !skuListForPim.find(item => item === sku)) {
				skuListForPim.push(sku);
			}
		});
		if (skuListForPim.length) {
			self.setState({
				pimDetailsServiceCallsCompleted: false,
			}, () => {
				// Fetch pim item data in batches of 100
				self.props.getPimDataInBatches(skuListForPim, 100, responseObject => {
					self.setState({
						pimDetailsList: self.state.pimDetailsList.concat(responseObject),
						pimDetailsServiceCallsCompleted: true,
					}, () => {
						callback && callback();
					});
				});
			});
		} else {
			self.setState({
				pimDetailsServiceCallsCompleted: true,
			}, () => {
				callback && callback();
			});
		}
	}
	// This is call back of checking if all order shipping parallel calls are completed or not
	checkParallelCallsCompleted() {
		const self = this;
		if (self.state.pimDetailsServiceCallsCompleted && self.state.getOrderShippingDetailsCallCompleted) {
			const { backupOrdersListResponse: ordersListResponse, pimDetailsList, orderShippingDetailsList } = self.state;
			const newOrderShippingDetailsList = [];
			orderShippingDetailsList.forEach((item) => {
				if (item && item.orderdetoutrec && item.orderdetoutrec.length) {
					const details = item.orderdetoutrec[0];
					const orderNumber = details.ordernumber.value.toString();
					const listRespdetails = ordersListResponse.responseObject.find(itm => itm.orderHeader.orderNumber.toString() === orderNumber);
					const orderDate = listRespdetails.orderHeader.orderDate || ""
					const items = [];
					let suggestedShipDate = "";
					const lineDetails = details.linedetailsrec && details.linedetailsrec.value && details.linedetailsrec.value.linedetails;
					if (lineDetails) {
						lineDetails.forEach(itm => {
							const lineId = itm.lineid.value;
							const productStatus = self.getAttributeValueByLineId(itm, 'supplytype');
							let scheduledShipDate = self.getAttributeValueByLineId(itm, 'scheduleshipdate');
							if(!scheduledShipDate && listRespdetails) {
								const lineDt = listRespdetails.orderDetail.orderLine.find(line => line.orderLineId === lineId);
								scheduledShipDate = lineDt ? self.props.pickTheDateFromString(lineDt.scheduleShipDate) : '';
							}
							suggestedShipDate = self.getAttributeValueByLineIdForSuggestedShipDate(itm, orderDate, 'suggestedshipdate');
							items.push({
								lineId,
								productStatus,
								scheduledShipDate: scheduledShipDate ? self.props.convertDateToTimeZone(scheduledShipDate).format('MM/DD/YYYY') : scheduledShipDate,
								suggestedShipDate: suggestedShipDate ? self.props.convertDateToTimeZone(suggestedShipDate).format('MM/DD/YYYY') : suggestedShipDate,
							});
						});
					}
					newOrderShippingDetailsList.push({
						orderNumber,
						items
					});
				}
			});
			ordersListResponse.responseObject.forEach((order) => {
				const { orderHeader } = order;
				const shippingMethod = orderHeader.shipmentMethod.description;
				const getOrderShippingDetailsData = orderShippingDetailsList.find(itm => itm.orderdetoutrec && itm.orderdetoutrec.length && itm.orderdetoutrec[0].ordernumber.value.toString() === orderHeader.orderNumber);
				let planNameAndReservedAllLine = true;
				if (getOrderShippingDetailsData) {
					let orderLineShippingDetails = getOrderShippingDetailsData && getOrderShippingDetailsData.orderdetoutrec;
					orderLineShippingDetails = orderLineShippingDetails && orderLineShippingDetails[0] && orderLineShippingDetails[0].linedetailsrec;
					orderLineShippingDetails = orderLineShippingDetails && orderLineShippingDetails.value && orderLineShippingDetails.value.linedetails;
					order.orderDetail.orderLine.forEach(itm => {
						if(itm.lineStatus.toUpperCase() === 'CANCELLED') {
							return null;
						}
						let data = orderLineShippingDetails.find(it => it.lineid.value === itm.orderLineId);
						const dataReservedQty = JSON.parse(JSON.stringify(data));
						if(shippingMethod.toLowerCase().indexOf('sds') !== -1) {
							data = data.isodetailsrec && data.isodetailsrec.value && data.isodetailsrec.value.isodetails;
							// PLAN NAME (TXXXXXXX) exists under the ISO Trip for every line that has an ISO
							if(data.length) {
								let temp = JSON.parse(JSON.stringify(data[0]));
								temp = temp.isodeliverydetailsrec && temp.isodeliverydetailsrec.value && temp.isodeliverydetailsrec.value.isodeliverydetails;
								temp = temp && temp.length && temp[0].tripdetailsrec && temp[0].tripdetailsrec.value ? temp[0].tripdetailsrec.value.tripdetails : null;
								if(!temp || temp.length === 0 || !(temp && temp.length === temp.filter(it => it.planname && it.planname.value).length)) {
									planNameAndReservedAllLine = false;
								}
							} else if(!dataReservedQty || !dataReservedQty.reservedquantity || dataReservedQty.reservedquantity.value !== itm.orderedQty) {
								planNameAndReservedAllLine = false;
							}
							data = data && data[0];
							if(data && data.isoreservationquantity) {
								itm.reserved = data.isoreservationquantity.value
							} else if(dataReservedQty && dataReservedQty.reservedquantity) {
								itm.reserved = dataReservedQty.reservedquantity.value
							}
						} else {
							data = data.deliverydetailsrec && data.deliverydetailsrec.value && data.deliverydetailsrec.value.deliverydetails;
							// PLAN NAME (TXXXXXXX) exists under the ISO Trip for every line that has an ISO
							if(data.length) {
								let temp1 = data[0];
								temp1 = temp1.tripdetailsrec && temp1.tripdetailsrec.value ? temp1.tripdetailsrec.value.tripdetails : null;
								if(!temp1 || temp1.length === 0 || !(temp1 && temp1.length === temp1.filter(it => it.planname && it.planname.value).length)) {
									planNameAndReservedAllLine = false;
								}
							} else if(!dataReservedQty || !dataReservedQty.reservedquantity || dataReservedQty.reservedquantity.value !== itm.orderedQty) {
								planNameAndReservedAllLine = false;
							}
							data = data && data[0];
							if(data && data.isoreservationquantity) {
								itm.reserved = data.isoreservationquantity.value
							} else if(dataReservedQty && dataReservedQty.reservedquantity) {
								itm.reserved = dataReservedQty.reservedquantity.value
							}
						}
						const orderStatus = self.props.getLineStatusFromMapping(itm.item, orderHeader.shipmentMethod && orderHeader.shipmentMethod.description, itm.lineStatus, itm);
						if (orderStatus.toUpperCase() !== 'CLOSED') {
							const pimData = pimDetailsList.find(it => it.item_number === itm.item);
							if(pimData) {
								itm.finalProductionDate = pimData.geego_final_production_date;
							}
						}
					});
				}
				order.planNameAndReservedAllLine = planNameAndReservedAllLine;
				// Calculate ETA date
				let eta = '';
				order.orderDetail.orderLine.forEach(itm => {
					if(self.props.checkItemIsServiceOrNot(itm.item) !== 'service' && itm.lineStatus.toUpperCase() !== 'CANCELLED') {
						eta = self.findSuggestedShipDate(itm, eta);
					}
				});
				order.eta = eta ? self.props.pickTheDateFromString(eta, 'MM/DD/YY') : eta;
			});
			self.setState({
				orderShippingDetailsList: newOrderShippingDetailsList,
				bkpOrderShippingDetailsList: JSON.parse(JSON.stringify(self.state.orderShippingDetailsList)),
				ordersListResponse: JSON.parse(JSON.stringify(ordersListResponse)),
				backupOrdersListResponse: JSON.parse(JSON.stringify(ordersListResponse)),
			});
		}
	}

	findSuggestedShipDate(itemDetail, suggestedShipDate) {
		const self = this;
	    if(itemDetail) {
	        if(itemDetail.suggestedShipDate) {
				const date = self.props.pickTheDateFromString(itemDetail.suggestedShipDate, 'YYYY/MM/DD');
	            suggestedShipDate = suggestedShipDate === '' || moment(suggestedShipDate).isBefore(moment(date)) ? date : suggestedShipDate;
	        } else if(itemDetail.scheduledShipDate) {
				const date = self.props.pickTheDateFromString(itemDetail.scheduledShipDate, 'YYYY/MM/DD');
	            suggestedShipDate = suggestedShipDate === '' || moment(suggestedShipDate).isBefore(moment(date)) ? date : suggestedShipDate;
	        }
	    }
	    return suggestedShipDate;
	}

	updateParams(formName, event) {
		//Reseting Errors on change
		let error = this.state[formName].error;
		let param = this.state[formName].param;
		for (var key in error) {
			if (error.hasOwnProperty(key)) {
				error[key] = '';
			}
		}
		if(formName === 'filterViewRequestByOrderNumber') {
			param = {
				...param,
				filterString: event.target.name === 'filterBy'?'':this.state[formName].param.filterString,
			};
		}
		param = {
			...param,
			[event.target.name]: event.target.value
		};
		// if(event.target.name === 'filterBy') {
		// 	param = {
		// 		...param,
		// 		modelNumber: '',
		// 	}
		// 	error = {
		// 		...error,
		// 		modelNumberError: '',
		// 	};
		// 	if(this.modelNumber)
		// 		this.modelNumber.value = '';
		// }
		this.setState({
			[formName]: {
				...this.state[formName],
				param,
				error
			},
			filterConfirmationMessage: ''
		});
	}

	handleSortBy(event) {
		let sortBy = event.target.value.split(',')[0],
			sortOrder = event.target.value.split(',')[1],
			ordersListResponse = this.state.ordersListResponse,
			isAnyDateFilter = sortBy.indexOf('Date') !== -1;
		var self = this;
		ordersListResponse = _.orderBy(this.state.ordersListResponse.responseObject, (e) => {
			return !isAnyDateFilter?e.orderHeader[sortBy]:self.props.formatDate(e.orderHeader[sortBy], 'MM/DD/YY')
		}, [sortOrder]);
		this.setState({
			sortBy: event.target.value,
			ordersListResponse: {
				...this.state.ordersListResponse,
				responseObject: ordersListResponse
			}
		})
	}

	handleFetchOrderDetails(orderNumber, wheretoRedirect, event) {
		event.preventDefault();
		var self = this;
		self.props.getOrderDetails('orderNumber='+orderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				});
			} else {
				//Save return product list into store
				self.props.saveViewRequestsListBackup(JSON.parse(JSON.stringify(self.state)));
				browserHistory.push('/' + wheretoRedirect);
			}
		});
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	getLineType(ebsLineType) {
		const ebsLineTypeList = [{
			ebsLineType: 'Return Line',
			displayLineType: 'Return'
		}, {
			ebsLineType: 'Standard Line',
			displayLineType: 'Standard'
		}, {
			ebsLineType: 'Other Credit',
			displayLineType: 'Credit'
		}, {
			ebsLineType: 'Bill Only Line',
			displayLineType: 'Bill Only'
		}];
		const data = ebsLineTypeList.find(itm => itm.ebsLineType === ebsLineType);
		return data ? data.displayLineType : '';
	}

	// Calculate Expected available date or product Status
	// This function is common for both of them.
	calculateAttributeValue(
		orderStatus,
		allLinesAreClosed,
		allLinesAreClosedOrArrivedAtSDS,
		planNameAndReservedAllLine,
		shippingMethod,
		returnValue,
		orderHeader,
		isReservedQuantityToReturn = false,
	) {
		const finalValue = isReservedQuantityToReturn ? returnValue : (orderStatus === 'Backorder Available' ? null : returnValue);
		return finalValue;
	}

	getExpectedShipDate(anyItemIsBackOrderHold, fullyReservedLine, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS,
		shippingMethod, eta, planNameAndReservedAllLine, orderHeader, orderDetail, anyItemHavingPlanName, item
	) {
		// In case of back order below line will calculate expected ship date and return
		let expectedShipDate = '';
		const cancelledItems = item.orderDetail.orderLine.filter(itm => itm.lineStatus.toUpperCase() === 'CANCELLED');
		if(cancelledItems.length === item.orderDetail.orderLine.length) {
			expectedShipDate = <p><strong>Cancelled</strong></p>;
		} else if(shippingMethod === 'ADC Will Call') {
			if(allLinesAreClosed) {
				expectedShipDate = <p><strong>Shipped</strong></p>;
			} else if(fullyReservedLine && anyItemHavingPlanName) {
				expectedShipDate = <p><strong>Ready for Pickup</strong></p>;
			} else if(fullyReservedLine && !anyItemHavingPlanName) {
				expectedShipDate = <p><strong>Fully Reserved</strong></p>;
			}
		} else if(shippingMethod.indexOf('SDS') === 0) {
			if(allLinesAreClosed) {
				expectedShipDate = <p><strong>Delivered</strong></p>;
			} else if(allLinesAreClosedOrArrivedAtSDS) {
				expectedShipDate = <p><strong>Arrived at SDS</strong></p>;
			}  else if(planNameAndReservedAllLine) {
				expectedShipDate = <p><strong>Shipment Planned</strong></p>;
			}
		} else if(shippingMethod === 'ADC Truckload' || shippingMethod === 'ADC LTL' || shippingMethod === 'Meet Truck') {
			if(allLinesAreClosed) {
				expectedShipDate = <p><strong>Shipped</strong></p>;
			} else if(fullyReservedLine && anyItemHavingPlanName) {
				expectedShipDate = <p><strong>Shipment Planned</strong></p>;
			} else if(fullyReservedLine && !anyItemHavingPlanName) {
				expectedShipDate = <p><strong>Fully Reserved</strong></p>;
			}
		}
		return expectedShipDate;
	}

    render() {
		const self = this;
		const {
			fromDate,
			toDate,
			maxFromDate,
			maxToDate,
			minToDate,
			invalidDateSelectionErrorMessage,
			filterViewRequestByDateRange: {
				error: {
					fromDateError,
					toDateError
				}
			},
		} = self.state;
        return (
			<div>
		        <div className="push d-none d-sm-block">
		          	<h1 className="pageTitle">View Returns & Credits</h1>
		        </div>
				<div className="push d-block d-sm-none mx-3">
		          	<h1 className="pageTitle">View Returns & Credits</h1>
		        </div>
			  	<p className="red bold">{this.state.errorMessage}</p>
				<p className="bold d-none d-sm-block">To view a return or credit, input the return/credit order number or choose a date range below</p>
				<p className="bold d-block d-sm-none mx-3">To view a return or credit, input the return/credit order number or choose a date range below</p>
				<p className="red bold">{this.state.filterConfirmationMessage}&nbsp; &nbsp;</p>
				<div className="push d-none d-sm-block">
					<div className="filterBoxType2 particularOrderShadedBox">
						<h3 style={{marginBottom: 14, marginTop: 14}}>Filter the list of orders by using the search criteria below.</h3>
						<div style={{float: 'left', width: '45%', position: 'relative'}}>
							<form onSubmit={this.filterReturnRequestByDateRange.bind(this)}>
								<div className="clearfix">
									{ invalidDateSelectionErrorMessage && <p className="red bold">{invalidDateSelectionErrorMessage}</p>}
									<div className={'pull-left ' + fromDateError}>
										<strong>From Date</strong> <DatePicker maxDate={maxFromDate ? self.props.convertDateToTimeZone(maxFromDate).hours(0).minutes(0).seconds(0).milliseconds(0) : maxFromDate} id="fromDate" placeholderText="Click to select a from date" selected={fromDate ? self.props.convertDateToTimeZone(fromDate).hours(0).minutes(0).seconds(0).milliseconds(0) : fromDate} onChange={this.handleChangeFromDate} />&nbsp;<var>(mm/dd/yyyy)</var>
									</div>
									<div className={'pull-right ' + toDateError}>
									<strong>To Date</strong> <DatePicker className='p-2 w-100' minDate={minToDate ? self.props.convertDateToTimeZone(minToDate).hours(0).minutes(0).seconds(0).milliseconds(0) : minToDate} maxDate={maxToDate ? self.props.convertDateToTimeZone(maxToDate).hours(0).minutes(0).seconds(0).milliseconds(0) : maxToDate} id="toDate" placeholderText="Click to select a to date" selected={toDate ? self.props.convertDateToTimeZone(toDate).hours(0).minutes(0).seconds(0).milliseconds(0) : toDate} onChange={this.handleChangeToDate} />&nbsp;<var>(mm/dd/yyyy)</var>
									</div>
								</div>
								<p>
				                	<label>
					                    <strong>Product #<span className="smalltext">(Optional)</span></strong><br />
					                    <input onChange={this.updateParams.bind(this, 'filterViewRequestByDateRange')} defaultValue={this.state.filterViewRequestByDateRange.param.productNumber} className="almostFullWidth" type="text" name="productNumber" placeholder="Partial or Full Product #" />
				                	</label>
				                </p>
								<p>
									<input className="blueButton" type="submit" value="Search" />
									&nbsp; &nbsp;
									<input type="reset" className="blue looksLikeALink" onClick={this.handleResetForm.bind(this, 'filterViewRequestByDateRange')} value="Clear Search" />
								</p>
							</form>
						</div>
						<div style={{float: 'left', width: '9.995%', position: 'relative', textAlign: 'center'}}>
							<div style={{width: '50%', borderRight: '1px solid #ccc', height: 22}} />
							<h3>OR</h3>
							<div style={{width: '50%', borderRight: '1px solid #ccc', height: 29}} />
						</div>
						<div style={{float: 'left', width: '45%', position: 'relative'}}>
							<form onSubmit={this.filterReturnRequestByRequestNumber.bind(this)}>
								<p style={{marginTop: 0}}>Filter by P.O. #, Return/Credit Order #, or Reference #</p>
								<p>
									<select ref={(select) => this.filterBy = select} defaultValue={this.state.filterViewRequestByOrderNumber.param.filterBy} name="filterBy" onChange={this.updateParams.bind(this, 'filterViewRequestByOrderNumber')} 
									className={"fullWidth " + this.state.filterViewRequestByOrderNumber.error.filterByError}>
										<option value="">Select one...</option>
										<option value="poNumber">P.O. #</option>
										<option value="orderNumber">Return/Credit Order #</option>
										<option value="referenceNumber">Reference #</option>
									</select>
								</p>
								<p>
									<input ref={(input) => this.filterString = input}
										onChange={this.updateParams.bind(this, 'filterViewRequestByOrderNumber')}
										className={"fullWidth " + this.state.filterViewRequestByOrderNumber.error.filterStringError}
										type="text"
										name="filterString"
										disabled={this.state.filterViewRequestByOrderNumber.param.filterBy === ''}
										value={this.state.filterViewRequestByOrderNumber.param.filterString}
									/>
								</p>
								<p>
									<input className="blueButton" type="submit" value="Search" />
									&nbsp; &nbsp;
									<input type="reset" className="blue looksLikeALink" onClick={this.handleResetForm.bind(this, 'filterViewRequestByOrderNumber')} value="Clear Search" />	
								</p>
							</form>
						</div>
						<div className="clear" />
					</div>
					</div>
				  <div className="push d-block d-sm-none m-3">
					<div className="filterBoxType2Mobile">
						<h3>Filter the list of orders by using the search criteria below.</h3>
						<div>
							<form onSubmit={this.filterReturnRequestByDateRange.bind(this)}>
									{ invalidDateSelectionErrorMessage && <p className="red bold">{invalidDateSelectionErrorMessage}</p>}
									<p className={fromDateError}>
										<strong>From Date</strong> 
										<DatePicker maxDate={maxFromDate ? self.props.convertDateToTimeZone(maxFromDate).hours(0).minutes(0).seconds(0).milliseconds(0) : maxFromDate} id="fromDate" 
											placeholderText="Click to select a from date" 
											className='p-2 filterBoxDatepicker'
											selected={fromDate ? self.props.convertDateToTimeZone(fromDate).hours(0).minutes(0).seconds(0).milliseconds(0) : fromDate} 
											onChange={this.handleChangeFromDate} />
										&nbsp;<var>(mm/dd/yyyy)</var>
									</p>
									<p className={toDateError}>
									<strong>To Date</strong> <DatePicker className='p-2 filterBoxDatepicker' minDate={minToDate ? self.props.convertDateToTimeZone(minToDate).hours(0).minutes(0).seconds(0).milliseconds(0) : minToDate} maxDate={maxToDate ? self.props.convertDateToTimeZone(maxToDate).hours(0).minutes(0).seconds(0).milliseconds(0) : maxToDate} id="toDate" placeholderText="Click to select a to date" selected={toDate ? self.props.convertDateToTimeZone(toDate).hours(0).minutes(0).seconds(0).milliseconds(0) : toDate} onChange={this.handleChangeToDate} />&nbsp;<var>(mm/dd/yyyy)</var>
									</p>
									<p>
										<label>
										<strong>Product #<span className="smalltext">(Optional)</span></strong><br />
										<input  onChange={this.updateParams.bind(this, 'filterViewRequestByDateRange')} defaultValue={this.state.filterViewRequestByDateRange.param.productNumber} 
										className="filterBoxDatepicker p-2" type="text" name="productNumber" placeholder="Partial or Full Product #" />
										</label>
				               		 </p>
									<p>
										<input className="blueButton" type="submit" value="Search" />
										&nbsp; &nbsp;
										<input type="reset" className="blue looksLikeALink" onClick={this.handleResetForm.bind(this, 'filterViewRequestByDateRange')} value="Clear Search" />
									</p>
							</form>
						</div>
						 <div style={{textAlign:"center", padding:"0.5rem"}}>
							<h3>-OR-</h3>
						</div>
						<div>
							<form onSubmit={this.filterReturnRequestByRequestNumber.bind(this)}>
								<p >Filter by P.O. #, Return/Credit Order #, or Reference #</p>
								<p>
									<select ref={(select) => this.filterBy = select} defaultValue={this.state.filterViewRequestByOrderNumber.param.filterBy} 
									name="filterBy" onChange={this.updateParams.bind(this, 'filterViewRequestByOrderNumber')} 
									className={"fullWidth p-2" + this.state.filterViewRequestByOrderNumber.error.filterByError}>
										<option value="">Select one...</option>
										<option value="poNumber">P.O. #</option>
										<option value="orderNumber">Return/Credit Order #</option>
										<option value="referenceNumber">Reference #</option>
									</select>
								</p>
								<p>
									<input ref={(input) => this.filterString = input}
										onChange={this.updateParams.bind(this, 'filterViewRequestByOrderNumber')}
										className={"fullWidth p-2" + this.state.filterViewRequestByOrderNumber.error.filterStringError}
										type="text"
										name="filterString"
										disabled={this.state.filterViewRequestByOrderNumber.param.filterBy === ''}
										value={this.state.filterViewRequestByOrderNumber.param.filterString}
									/>
								</p>
								<p>
									<input className="blueButton" type="submit" value="Search" />
									&nbsp; &nbsp;
									<input type="reset" className="blue looksLikeALink" onClick={this.handleResetForm.bind(this, 'filterViewRequestByOrderNumber')} value="Clear Search" />
								</p>
							</form>
						</div>
					</div>
	          	</div>
				{this.state.ordersListResponse && this.state.ordersListResponse.status &&
			         <div className="push d-none d-sm-block">
						<div className="columns twoColumns">
			            	<div className="column column1 verticalAlignBottom">&nbsp;</div>
			            	<div className="column column2 verticalAlignBottom textRight">
			              		{this.state.ordersListResponse && this.state.ordersListResponse.responseObject && this.state.ordersListResponse.responseObject.length?<a onClick={this.handleExport.bind(this)} className="withIcon withExportIcon noUnderline bold uppercase" href="">Export</a>:null}&nbsp;
			            	</div>
			          	</div>
			          	<div className="captionAboveTable">
				            <div className="columns twoColumns">
				              	<div className="column">
				                	<div className="bold big">{this.state.ordersListResponse && this.state.ordersListResponse.status && this.state.ordersListResponse.responseObject.length} Orders</div>
				              	</div>
				              	<div className="column textRight">
					                <form className="manageOrdersSortBy" name="manageOrdersSortBy" id="manageOrdersSortBy">
					                  	<label>
					                    	Sort by: &nbsp;
											<select onChange={this.handleSortBy.bind(this)} name="sortBy" defaultValue={this.state.sortBy}>
												<option value="orderNumber,desc">CSO (Order number)</option>
												<option value="enteredBy,desc">Entered By</option>
												<option value="orderStatus,desc">Status</option>
											</select>
					                  	</label>
					                </form>
				              	</div>
				            </div>
			          	</div>
			          	<table className="dataTable viewRequestCreditTable">
							<thead>
								<tr>
									<th className="status">Status</th>
									<th className="viewOrderInfo">Return/Credit Information</th>
									<th colSpan={ 3 } className="forInnerTable">
										<table className="innerTable">
											<thead>
												<tr>
													<th className="productNumber">Product</th>
													<th className="serial">Serial #</th>
													<th className="lineType text-left">Line Type</th>
													<th className="quantityOrdered">Quantity<br />Ordered</th>
													<th className="quantityReserved">Reserved</th>
													<th className="lineStatus">Line Status<br/><a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "LineStatusDescriptionsOverlayDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></th>
													<th className="expectedAvailableDate">Expected<br />Available Date</th>
													<th className="productStatus">Product Status<br/><a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "ProductStatusDescriptionsOverlayDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></th>
													<th className="originalCSO">Original CSO</th>
												</tr>
											</thead>
										</table>
									</th>
								</tr>
							</thead>
			            	<tbody>
								{this.state.ordersListResponse && this.state.ordersListResponse.status && this.state.ordersListResponse.responseObject.length === 0
									?<tr>
										<td colSpan={6}>No orders found meeting the specified criteria; please try your search again.</td>
									</tr>
									:null
								}
								{this.state.ordersListResponse && this.state.ordersListResponse.status && this.state.ordersListResponse.responseObject.length > 0 && this.state.ordersListResponse.responseObject.map((item, index) => {
									let { orderHeader, orderDetail, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, anyItemIsBackOrderHold, /* allLinesAreBackOrderTransferred */ } = item;
									let originalOrderNumber = '';
									const isThereAnyStandardLine = orderDetail.orderLine.find(itm => self.props.getItemTypeByName(itm.item) !== 'S' && self.getLineType(itm.lineType) === 'Standard' && itm.lineStatus.toUpperCase() !== 'CANCELLED') ? true : false;
									// Changes Added as Part of WCP-6942
									if(orderDetail.orderLine && orderDetail.orderLine.length) {
										orderDetail.orderLine.forEach(line => {
											if(line.returnAttribute1 && line.returnAttribute1 != undefined) {
												originalOrderNumber = line.returnAttribute1;
											}
										});
									}
									const shippingMethod = orderHeader.shipmentMethod && orderHeader.shipmentMethod.description;
									let isBackOrderAvailable = false;
									const odrDtl = self.state.orderShippingDetailsList.find(order => order.orderNumber === orderHeader.orderNumber);
									const fullyReservedLine = orderDetail.orderLine.find(itm => self.props.getItemTypeByName(itm.item) !== 'S' && self.getLineType(itm.lineType) === 'Standard' && itm.lineStatus.toUpperCase() !== 'CANCELLED' && itm.reserved !== itm.orderedQty) ? false : true;
									const noOfRows = orderDetail.orderLine.filter(itm => itm.lineStatus.toUpperCase() !== 'CANCELLED').length;
									return <tr key={index}>
										<td className="status">
											<span>{orderHeader.orderStatus}</span><br/>
										</td>
										<td className="viewOrderInfo">
											<a className="bold" href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader.orderNumber, 'viewrequestsorderdetails')}>{orderHeader.orderNumber}</a><br/>
											{orderHeader.orderSourceRef.indexOf("CTN") === 0 &&
												<span><strong>Reference#:</strong> {orderHeader.orderSourceRef}<br /></span>
											}
											<strong>P.O.#:</strong> {orderHeader.ponumber}<br />
											<strong>Entered Date:</strong> {this.props.formatDate(orderHeader.orderDate, 'MM/DD/YY')}<br />
											<strong>Entered By:</strong> {orderHeader.enteredBy}<br />
										</td>
										<td colSpan={3} className="forInnerTable">
				                  			<table className="innerTable">
												<tbody>
													{orderDetail.orderLine.map((itm, ind) => {
														if(itm.lineStatus.toUpperCase() === 'CANCELLED') {
															return null;
														}
														let quantity = itm.orderedQty;
														if(self.getLineType(itm.lineType) === 'Return' || self.getLineType(itm.lineType) === 'Credit') {
															quantity *= -1;
														}
														let suggestedShipDate = '';
														let prdStatus = '';
														let expectedAvailableDate = '';
														let productStatus = '';
														let reservedQty = '';
														const orderStatus = self.props.getLineStatusFromMapping(itm.item, orderHeader.shipmentMethod && orderHeader.shipmentMethod.description, itm.lineStatus, itm);
														if(self.getLineType(itm.lineType) === 'Standard') {
															if(!isBackOrderAvailable && orderStatus === 'Backorder Available') {
																isBackOrderAvailable = true;
															}
															if(odrDtl) {
																const itemDetail = odrDtl.items.find(it => it.lineId.toString() === itm.orderLineId.toString());
																// if(self.state.selectedOrderType === 'BACKORDER' || (self.isValidSearchForMakingGettingOrderShippingDetailsParallelCalls() && orderHeader.orderStatus === 'BOOKED')) {
																	suggestedShipDate = itemDetail && itemDetail.suggestedShipDate ? self.props.pickTheDateFromString(itemDetail.suggestedShipDate, 'MM/DD/YY') : '';
																	if(!suggestedShipDate) {
																		suggestedShipDate = itemDetail && itemDetail.scheduledShipDate ? self.props.pickTheDateFromString(itemDetail.scheduledShipDate, 'MM/DD/YY') : '';
																	}
																	prdStatus = itemDetail && itemDetail.productStatus;
																// } else {
																// 	if(itm.reserved < itm.orderedQty) {
																// 		suggestedShipDate = itm.suggestedShipDate || itm.scheduledShipDate;
																// 		suggestedShipDate = suggestedShipDate ? moment(suggestedShipDate).format('MM/DD/YY') : suggestedShipDate;
																// 		prdStatus = itm.productStatus;
																// 	} else if(itm.reserved === itm.orderedQty) {
																// 		suggestedShipDate = '';
																// 		prdStatus = '';
																// 	}
																// }
															}
															if (suggestedShipDate && itm.finalProductionDate) {
																suggestedShipDate = self.validateFP({finalProductionDate: itm.finalProductionDate, suggestedShipDate});
															}
															expectedAvailableDate = self.calculateAttributeValue(orderStatus, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, item.planNameAndReservedAllLine, shippingMethod, suggestedShipDate, orderHeader);
															productStatus = self.calculateAttributeValue(orderStatus, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, item.planNameAndReservedAllLine, shippingMethod, prdStatus, orderHeader);
															reservedQty = self.calculateAttributeValue(orderStatus, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, item.planNameAndReservedAllLine, shippingMethod, itm.reserved, orderHeader, true);
														}
														let filteredReplacementLineStatus = true;
														if(itm.itemType == null || itm.itemType == ""){
															if((itm.item.indexOf("M") === 0 && itm.item.length === 4) ||  itm.item.indexOf("UNCRATE") !== -1 || itm.item.indexOf("DELIVERY") !== -1 || itm.item.indexOf("SDS TRIP") !== -1 || itm.lineStatus.toLowerCase() ==	"closed"){
																		filteredReplacementLineStatus = false;
																	}else{
																		filteredReplacementLineStatus = true;
																	}
																}else if(itm.itemType == "DELIVERY SERVICE"){
																	filteredReplacementLineStatus =false ;
																}
														return <tr key={ind}>
															<td className="productNumber">{itm.item}</td>
															<td className="serial">{itm.userItemDescription.split(/[ ,]+/)[0]}</td>
															<td className="lineType text-left">
																{self.getLineType(itm.lineType)}
															</td>
															<td className="quantityOrdered txt-ctr">{quantity}</td>
															<td className="quantityReserved">
															{filteredReplacementLineStatus && !self.props.isItSpecialService(itm.item) && self.getLineType(itm.lineType) === 'Standard' && orderStatus.toLowerCase() != "arrived at sds" ? reservedQty : '' }
															</td>
															<td className="lineStatus">
																{orderStatus}
															</td>
															<td className={`expectedAvailableDate ${productStatus === 'Prod TBD' ? 'red' : ''}`}>
															{filteredReplacementLineStatus && !fullyReservedLine && !self.props.isItSpecialService(itm.item) && self.getLineType(itm.lineType) === 'Standard' && reservedQty !== quantity && orderStatus.toLowerCase() != "arrived at sds"? expectedAvailableDate : '' }
															</td>
															<td className={`productStatus ${productStatus === 'Prod TBD' ? 'red' : ''}`}>
															{filteredReplacementLineStatus && self.getLineType(itm.lineType) === 'Standard' && reservedQty !== quantity && orderStatus.toLowerCase() != "arrived at sds" ? productStatus : '' }
															</td>
															<td className="originalCSO txt-ctr" rowSpan={noOfRows}>
																{ind === 0 ? originalOrderNumber : ''}
																{ind === 0 && isThereAnyStandardLine ? self.getExpectedShipDate(anyItemIsBackOrderHold, fullyReservedLine, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, shippingMethod, item.eta, item.planNameAndReservedAllLine, orderHeader, odrDtl, item.anyItemHavingPlanName, item) : ''}
															</td>
														</tr>
													})}
												</tbody>
											</table>
				                		</td>
										{/*
										<td className="enteredBy">{orderHeader.orderSourceRef.indexOf("CTN") === 0 ? orderHeader.orderSourceRef : ''}</td>
										<td className="enteredBy">{enteredBy}</td>
										<td className="enteredBy">{originalOrderNumber}</td>
										<td className="dateEntered">{this.props.formatDate(orderHeader.createdDate, 'MM/DD/YY')}</td>
										<td className="returnStatus">{orderHeader.orderStatus}</td>
										*/}
									</tr>
								})}
			            	</tbody>
			          	</table>
			        </div>
				}
				{this.state.ordersListResponse && this.state.ordersListResponse.status &&
			        <div className="push d-block d-sm-none m-3">
						<div className="columns twoColumns">
			            	<div className="column column1 verticalAlignBottom">&nbsp;</div>
			            	<div className="column column2 verticalAlignBottom textRight">
			              		{this.state.ordersListResponse && this.state.ordersListResponse.responseObject && this.state.ordersListResponse.responseObject.length?<a onClick={this.handleExport.bind(this)} className="withIcon withExportIcon noUnderline bold uppercase" href="">Export</a>:null}&nbsp;
			            	</div>
			          	</div>
			          	<div className="captionAboveTable">
				              	<div>
				                	<div className="bold big">{this.state.ordersListResponse && this.state.ordersListResponse.status && this.state.ordersListResponse.responseObject.length} Orders</div>
				              	</div>
			          	</div>
						  <div style={{backgroundColor:"#f3f3f3"}}>
					                <form className="manageOrdersSortBy p-3" name="manageOrdersSortBy" id="manageOrdersSortBy">
					                  	<label>
					                    	Sort by: &nbsp;
											<select style={{padding:"0.5rem", width:"14rem",borderRadius:"10px" }} onChange={this.handleSortBy.bind(this)} name="sortBy" defaultValue={this.state.sortBy}>
												<option value="orderNumber,desc">CSO (Order number)</option>
												<option value="enteredBy,desc">Entered By</option>
												<option value="orderStatus,desc">Status</option>
											</select>
					                  	</label>
					                </form>
				        </div>
						{this.state.ordersListResponse && this.state.ordersListResponse.status && this.state.ordersListResponse.responseObject.length === 0
									?<tr>
										<td colSpan={6}>No orders found meeting the specified criteria; please try your search again.</td>
									</tr>
									:null
						}
						{this.state.ordersListResponse && this.state.ordersListResponse.status && this.state.ordersListResponse.responseObject.length > 0 && this.state.ordersListResponse.responseObject.map((item, index) => {
									let { orderHeader, orderDetail, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, anyItemIsBackOrderHold, /* allLinesAreBackOrderTransferred */ } = item;
									let originalOrderNumber = '';
									const isThereAnyStandardLine = orderDetail.orderLine.find(itm => self.props.getItemTypeByName(itm.item) !== 'S' && self.getLineType(itm.lineType) === 'Standard' && itm.lineStatus.toUpperCase() !== 'CANCELLED') ? true : false;
									if(orderDetail.orderLine && orderDetail.orderLine.length) {
										orderDetail.orderLine.forEach(line => {
											if(line.returnAttribute1 && line.returnAttribute1 != undefined) {
												originalOrderNumber = line.returnAttribute1;
											}
										});
									}
									const shippingMethod = orderHeader.shipmentMethod && orderHeader.shipmentMethod.description;
									let isBackOrderAvailable = false;
									const odrDtl = self.state.orderShippingDetailsList.find(order => order.orderNumber === orderHeader.orderNumber);
									const fullyReservedLine = orderDetail.orderLine.find(itm => self.props.getItemTypeByName(itm.item) !== 'S' && self.getLineType(itm.lineType) === 'Standard' && itm.lineStatus.toUpperCase() !== 'CANCELLED' && itm.reserved !== itm.orderedQty) ? false : true;
									const noOfRows = orderDetail.orderLine.filter(itm => itm.lineStatus.toUpperCase() !== 'CANCELLED').length;
									return  <div className="accordion accordion-borderless" id={`accordionViewRequest${index}`}  key={index}>
												<div>
												<h2 className="accordion-header" id={`flush-ViewRequest${index}`}>
												<button className="accordion-button mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseViewRequest${index}`} aria-expanded="true" aria-controls={`#flush-collapseViewRequest${index}`}>
														{`ORDER `} <a className="bold ps-2" href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader.orderNumber, 'viewrequestsorderdetails')}>{orderHeader.orderNumber}</a><br/>
													</button>
													</h2>
													<div id={`flush-collapseViewRequest${index}`} className="accordion-collapse collapse show" aria-labelledby={`flush-ViewRequest${index}`}>
													<table className='orderTable'>
														<tbody>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>STATUS</td>
																<td className="status"><span>{orderHeader.orderStatus}</span></td>
															</tr>
															<tr className='border-bottom' style={{backgroundColor:"#f3f3f3", color: "#092c74"}}>
																<td className='p-1 fw-bold fs-6 ps-3'>Return/Credit Information</td>
																<td> {" "}</td>
															</tr>
															<tr className='border-bottom'  style={{backgroundColor:"#f3f3f3"}}>
																<td className='p-1 fw-bold ps-3'>REFERENCE #</td>
																	{orderHeader.orderSourceRef.indexOf("CTN") === 0 &&	<span> {orderHeader.orderSourceRef}<br /></span>}
															</tr>
															<tr className='border-bottom'  style={{backgroundColor:"#f3f3f3"}}>
																<td className='p-1 fw-bold ps-3'>P.O.#</td>
																<td> {orderHeader.ponumber}</td>
															</tr>
															<tr className='border-bottom'  style={{backgroundColor:"#f3f3f3"}}>
																<td className='p-1 fw-bold ps-3'>ENTERED DATE</td>
																<td> {this.props.formatDate(orderHeader.orderDate, 'MM/DD/YY')}</td>
															</tr>
															<tr  style={{backgroundColor:"#f3f3f3"}}>
																<td className='p-1 fw-bold ps-3'>ENTERED BY</td>
																<td className="product">{orderHeader.enteredBy}</td>
															</tr>
															<tr>
																<td colSpan={2}>																	
																	<table style={{width:"100%", margin:0}}>
																		<tbody>
																			{orderDetail.orderLine.map((itm, ind) => {
																				if(itm.lineStatus.toUpperCase() === 'CANCELLED') {
																					return null;
																				}
																				let quantity = itm.orderedQty;
																				if(self.getLineType(itm.lineType) === 'Return' || self.getLineType(itm.lineType) === 'Credit') {
																					quantity *= -1;
																				}
																				let suggestedShipDate = '';
																				let prdStatus = '';
																				let expectedAvailableDate = '';
																				let productStatus = '';
																				let reservedQty = '';
																				const orderStatus = self.props.getLineStatusFromMapping(itm.item, orderHeader.shipmentMethod && orderHeader.shipmentMethod.description, itm.lineStatus, itm);
																				if(self.getLineType(itm.lineType) === 'Standard') {
																					if(!isBackOrderAvailable && orderStatus === 'Backorder Available') {
																						isBackOrderAvailable = true;
																					}
																					if(odrDtl) {
																						const itemDetail = odrDtl.items.find(it => it.lineId.toString() === itm.orderLineId.toString());
																							suggestedShipDate = itemDetail && itemDetail.suggestedShipDate ? self.props.pickTheDateFromString(itemDetail.suggestedShipDate, 'MM/DD/YY') : '';
																							if(!suggestedShipDate) {
																								suggestedShipDate = itemDetail && itemDetail.scheduledShipDate ? self.props.pickTheDateFromString(itemDetail.scheduledShipDate, 'MM/DD/YY') : '';
																							}
																							prdStatus = itemDetail && itemDetail.productStatus;
																					}
																					if (suggestedShipDate && itm.finalProductionDate) {
																						suggestedShipDate = self.validateFP({finalProductionDate: itm.finalProductionDate, suggestedShipDate});
																					}
																					expectedAvailableDate = self.calculateAttributeValue(orderStatus, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, item.planNameAndReservedAllLine, shippingMethod, suggestedShipDate, orderHeader);
																					productStatus = self.calculateAttributeValue(orderStatus, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, item.planNameAndReservedAllLine, shippingMethod, prdStatus, orderHeader);
																					reservedQty = self.calculateAttributeValue(orderStatus, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, item.planNameAndReservedAllLine, shippingMethod, itm.reserved, orderHeader, true);
																				}
																				let filteredReplacementLineStatus = true;
																						if(itm.itemType == null || itm.itemType == ""){
																							if((itm.item.indexOf("M") === 0 && itm.item.length === 4) ||  itm.item.indexOf("UNCRATE") !== -1 || itm.item.indexOf("DELIVERY") !== -1 || itm.item.indexOf("SDS TRIP") !== -1 || itm.lineStatus.toLowerCase() ==	"closed"){
																								filteredReplacementLineStatus = false;
																							}else{
																								filteredReplacementLineStatus = true;
																							}
																						}else if(itm.itemType == "DELIVERY SERVICE"){
																							filteredReplacementLineStatus =false ;
																						}
																						return <div id={`accordionViewRequestInner${index}`}  key={ind}>
																							<div >
																							<h2 className="accordion-header" id={`flush-ViewRequestInner${index}`}>
																								<button className="accordion-button collapsed mobileAccButton" type="button" data-bs-toggle="collapse" 
																								data-bs-target={`#flush-collapseViewRequestInner${index}`} aria-expanded="false" aria-controls={`flush-collapseViewRequestInner${index}`}>
																									{`ITEM `} {<div style={{paddingLeft:"1rem"}}>{itm.item}</div>}
																								</button>
																								</h2>
																								<div id={`flush-collapseViewRequestInner${index}`} className="accordion-collapse collapse" aria-labelledby={`flush-ViewRequestInner${index}`}>
																										<table className='orderTable'>
																											<tbody>
																											{itm.userItemDescription && <tr className='border-bottom'>
																													<td className='p-3 fw-bold'>SERIAL #</td>
																													<td className="serial">{itm.userItemDescription.split(/[ ,]+/)[0]}</td>
																											</tr>}
																													{itm.lineType && <tr className='border-bottom'>
																													<td className='p-3 fw-bold'>LINE TYPE</td>
																													<td className="lineType text-left">{self.getLineType(itm.lineType)}</td>
																													</tr>}
																													{quantity &&<tr className='border-bottom'>
																													<td className='p-3 fw-bold'>QUANTITY ORDERED</td>
																													<td className="quantityOrdered txt-ctr">{quantity}</td>		
																												</tr>}
																												{(filteredReplacementLineStatus && !self.props.isItSpecialService(itm.item) && self.getLineType(itm.lineType) === 'Standard' && orderStatus.toLowerCase() != "arrived at sds")  &&<tr>
																													<td className='p-3 fw-bold'>RESERVED</td>
																													<td className="quantityReserved">{filteredReplacementLineStatus && !self.props.isItSpecialService(itm.item) && self.getLineType(itm.lineType) === 'Standard' && orderStatus.toLowerCase() != "arrived at sds" ? reservedQty : '' }</td>
																													</tr>}
																												{orderStatus &&<tr className='border-bottom'>
																													<td className='p-3 fw-bold'>LINE STATUS <a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "LineStatusDescriptionsOverlayDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></td>
																													<td className="lineStatus">{orderStatus}</td>
																													</tr>}
																												{(filteredReplacementLineStatus && !fullyReservedLine && !self.props.isItSpecialService(itm.item) && self.getLineType(itm.lineType) === 'Standard'
																														 && reservedQty !== quantity && orderStatus.toLowerCase() != "arrived at sds") && <tr className='border-bottom'>
																													<td className='p-3 fw-bold'>EXPECTED AVAILABLE DATE</td>
																													<td className={`expectedAvailableDate ${productStatus === 'Prod TBD' ? 'red' : ''}`}>
																														{filteredReplacementLineStatus && !fullyReservedLine && !self.props.isItSpecialService(itm.item) && self.getLineType(itm.lineType) === 'Standard'
																														 && reservedQty !== quantity && orderStatus.toLowerCase() != "arrived at sds"? expectedAvailableDate : '' }
																													</td>
																													</tr>}
																												{(filteredReplacementLineStatus && self.getLineType(itm.lineType) === 'Standard' && reservedQty !== quantity && orderStatus.toLowerCase() != "arrived at sds") && <tr>
																													<td className='p-3 fw-bold'>PRODUCT STATUS<a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "ProductStatusDescriptionsOverlayDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></td>
																													<td className={`productStatus ${productStatus === 'Prod TBD' ? 'red' : ''}`}>
																														{filteredReplacementLineStatus && self.getLineType(itm.lineType) === 'Standard' && reservedQty !== quantity && orderStatus.toLowerCase() != "arrived at sds" ? productStatus : '' }
																													</td>
																													</tr>}
																													{(ind === 0 && isThereAnyStandardLine) &&	<tr>
																													<td className='p-3 fw-bold'>ORIGINAL CSO</td>
																													<td className="originalCSO txt-ctr" rowSpan={noOfRows}>
																														{ind === 0 ? originalOrderNumber : ''}
																														{ind === 0 && isThereAnyStandardLine ? self.getExpectedShipDate(anyItemIsBackOrderHold, fullyReservedLine, allLinesAreClosed, allLinesAreClosedOrArrivedAtSDS, shippingMethod, item.eta, item.planNameAndReservedAllLine, orderHeader, odrDtl, item.anyItemHavingPlanName, item) : ''}
																													</td>
																													</tr>}
																											</tbody>
																										</table>
																								</div>
																							</div>
																					</div>
																			})}
																		</tbody>
																	</table>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
												</div>
											</div>
								})}
			        </div>
				}
				{this.state.showLineStatusDescriptionsOverlayDialog?<LineStatusDescriptionsOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showProductStatusDescriptionsOverlayDialog?<ProductStatusDescriptionsOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
	      	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderList: (queryStringParams, callback) => dispatch(getOrderList(queryStringParams, callback)),
	getOrderDetails: (queryStringParams, callback) => dispatch(getOrderDetails(queryStringParams, callback)),
	saveViewRequestsListBackup: (viewRequestsListBackup) => dispatch(saveViewRequestsListBackup(viewRequestsListBackup)),
	ajaxRequestInitiated: () => dispatch(ajaxRequestInitiated()),
	ajaxRequestCompleted: () => dispatch(ajaxRequestCompleted()),
	exportManageOrdersDetails: (payload, queryStringParams, callback) => dispatch(exportManageOrdersDetails(payload, queryStringParams, callback)),
});

ViewReturnRequests = connect(mapStateToProps, mapDispatchToProps)(ViewReturnRequests);
export default ViewReturnRequests;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/viewRequests.js